import React from 'react';
import { useSelector } from 'react-redux';
import { selectItemsByState } from '../app/dataSelectors';
import Datatable from '../components/Datatable'
import MonthlyVisualization from '../components/MonthlyVisualization';
import TimePeriodVisualization from '../components/TimePeriodVisualization';
import { CONFLICT_RESOLUTION_PROGRAM, CRP, CRP_INDICATORS, DP, DP_INDICATORS } from '../services/util';

const pageTitle = (stateName) => {
  if (!stateName) return DP.title;
  if (stateName === CONFLICT_RESOLUTION_PROGRAM.name) {
    return CRP.title;
  }
  return stateName;
}

const StatePage = ({usState, program}) => {
  const stateName = usState ? usState.name : null;
  const programLabel = program ? program.label: null;
  const title = pageTitle(stateName);
  const stateData = useSelector(selectItemsByState(stateName));

  const filteredData = stateData.filter((stateItem) =>
    stateItem.Program === program.label);

  const columnsToShow = {
    State: !stateName,
    Program: !programLabel,
  }
  
  const indicators = programLabel === CRP.label ? CRP_INDICATORS : DP_INDICATORS;

  return (
    <div>
      <p style={{ fontSize: "48px", textAlign: 'center', margin: "0"}}> {title} </p>
      <MonthlyVisualization data={filteredData} indicators={indicators} programLabel={programLabel}/>
      <TimePeriodVisualization data={filteredData} indicators={indicators} stateName={stateName}/>
      <Datatable data={filteredData} showCol={columnsToShow} indicators={indicators}/>
    </div>
  );
}

export default StatePage;
